import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=eb4ea4fe"
import script from "./OffersList.vue?vue&type=script&lang=js"
export * from "./OffersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports